var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useLayoutEffect, useState } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "../di/index";
import { useSelector } from "react-redux";
import { ECurrentLoginComponent, ILoginScreenState, } from "@domains/salesFeatures/Login/entities/iLogin";
import ErrorExclamation from "@frameworks/shared-library/components/ErrorExclamation";
import { useNavigate } from "react-router-dom";
import { Col } from "react-bootstrap";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
import homeDI from "@frameworks/salesjourney/components/Home/di/index";
import { ERole } from "../Login";
import ForgotIDPasswordButton from "../common/ForgotIDPasswordButton";
import LoginCommonInputButton from "../common/LoginCommonInputButton";
import InputPasswordToggle from "@frameworks/shared-library/components/InputPasswordToggle";
import Loader from "@frameworks/shared-library/components/Loader";
import VerificationMsg from "@frameworks/salesjourney/components/Generic/VerificationMsg";
import profileDi from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { createHash, generateAppId } from "./constant";
import { removeLocalStorageDataIfExist } from "@frameworks/salesjourney/components/constant";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import microsoftLogo from "@frameworks/shared-library/assets/images/SalesJourney/Login/microsoft.png";
var LoginMain = function (props) {
    var _a, _b, _c;
    var otpLength = 6;
    var errorState = useSelector(function (state) { return state.Login.LoginReducer.commonData.errorData; });
    var _d = __read(useState(""), 2), appId = _d[0], setAppId = _d[1];
    // const [hashedCredential, setHashedCredential] = useState<string>("");
    var currentLoginComponent = useSelector(function (state) { return state.Login.LoginComponentReducer.reducersData; });
    var _e = __read(React.useState(""), 2), emailError = _e[0], setEmailError = _e[1];
    var navigate = useNavigate();
    var _f = __read(React.useState(), 2), password = _f[0], setPassword = _f[1];
    var _g = __read(React.useState(""), 2), otp = _g[0], setOtp = _g[1];
    var _h = __read(React.useState(), 2), otpLoader = _h[0], setShowOtpLoader = _h[1];
    var _j = __read(React.useState(false), 2), showOtp = _j[0], setShowOtp = _j[1];
    var _k = __read(React.useState(false), 2), resendOtp = _k[0], setResendOtp = _k[1];
    var _l = __read(useState(false), 2), resendOTPLoader = _l[0], setResendOTPLoader = _l[1];
    var _m = __read(React.useState({
        isOpen: false,
        errorMessage: "",
    }), 2), serverError = _m[0], setServerError = _m[1];
    // const [formValidation, setFormValidation] = React.useState({
    //   userId: "",
    //   password: "",
    // });
    var _o = __read(React.useState(false), 2), isAccountBlocked = _o[0], setIsAccountBlocked = _o[1];
    var _p = __read(React.useState(false), 2), isShowLoader = _p[0], setIsShowLoader = _p[1];
    var _q = __read(React.useState(true), 2), passwordMask = _q[0], setPasswordMask = _q[1];
    var _r = __read(useState(false), 2), isSaarthi = _r[0], setIsSaarthi = _r[1];
    var _s = __read(useState(""), 2), saarthiMsg = _s[0], setSaarthiMsg = _s[1];
    var passwordInputRef = React.useRef(null);
    var loginData = useSelector(function (state) { return state.Login.LoginReducer.reducersData.loginData; });
    var resendOTP = function () {
        setResendOTPLoader(true);
        var payload = {
            userName: props.userId,
            userKey: password,
            loginFor: props.loginFor,
            verificationkey: props.userId,
        };
        di.login
            .resendOTP(payload)
            .then(function (response) {
            setResendOTPLoader(false);
            setResendOtp(false);
            setOtp("");
            if (response.status) {
                setServerError({
                    isOpen: false,
                    errorMessage: "",
                });
            }
        })
            .catch(function (error) {
            setResendOTPLoader(false);
        });
    };
    var validateOTP = function () {
        setShowOtpLoader(true);
        var payload = {
            tokenid: loginData.tokenId,
            otptxt: otp,
            empType: props.loginFor,
            verificationkey: props.userId,
            loginFor: props.loginFor,
            isMobile: process.env.NODE_ENV !== "cug" && process.env.NODE_ENV !== "production",
            loginVia: "sj-web",
            userName: props === null || props === void 0 ? void 0 : props.userId,
            hashStrUser: loginData.hashStrUser,
        };
        di.login
            .getValidateOTPData(payload)
            .then(function (resp) {
            if (resp !== null && resp !== undefined) {
                var partnerCategory = localStorage.getItem("partnerCategory");
                var access_token = localStorage.getItem("access_token");
                if (partnerCategory &&
                    access_token !== null &&
                    access_token !== undefined &&
                    access_token !== undefined &&
                    (access_token === null || access_token === void 0 ? void 0 : access_token.length) > 0) {
                    getMenuList(partnerCategory);
                }
            }
        })
            .catch(function (e) { });
    };
    var userLogin = function () {
        setIsShowLoader(true);
        removeLocalStorageDataIfExist([
            ELocalStorageKeys.AccessToken,
            ELocalStorageKeys.IsRHAbove,
            ELocalStorageKeys.LoginType,
            ELocalStorageKeys.PartnerCategory,
            ELocalStorageKeys.CadCam,
            ELocalStorageKeys.LeaddashFilterdata,
        ]);
        createHash(props.userId)
            .then(function (hashedCredential) {
            var payload = {
                userName: props.userId,
                userKey: password,
                loginFor: props.loginFor,
                agentId: appId,
                verificationkey: hashedCredential,
                isMobile: process.env.NODE_ENV !== "cug" &&
                    process.env.NODE_ENV !== "production",
                loginVia: "sj-web",
            };
            // console.log("hashedCredential", hashedCredential);
            login(payload);
        })
            .catch(function (error) {
            console.log("HASHING ERROR", error);
        });
    };
    var login = function (payload) {
        di.login
            .getLogingFeatureData(payload)
            .then(function () {
            var partnerCategory = localStorage.getItem(ELocalStorageKeys.PartnerCategory);
            if (partnerCategory) {
                getMenuList(partnerCategory);
            }
            setIsShowLoader(false);
        })
            .catch(function (err) {
            setIsShowLoader(false);
        });
    };
    var getExpiringLeads = function () {
        var req = {
            page: "1",
            pageSize: "100",
        };
        homeDI.home.getExpiringLeads(req);
    };
    var userUnblockCheck = function () {
        setIsShowLoader(true);
        var payload = {
            userName: props.userId,
            loginFor: props.loginFor,
        };
        di.login
            .userUnblockCheck(payload)
            .then(function (resp) {
            props.setUserDataForUnblock(resp.data);
            setIsShowLoader(false);
            di.login.changeCurrentLoginComponent({
                currentComponent: ECurrentLoginComponent.UNBLOCK_ACCOUNT,
            });
        })
            .catch(function (error) {
            setIsShowLoader(false);
            di.login.changeCurrentLoginComponent({
                currentComponent: ECurrentLoginComponent.UNBLOCK_ACCOUNT,
                extraConfig: {
                    currentActiveTab: ERole.Partner,
                    messageIcon: React.createElement("i", { className: "edel-icon-validation" }),
                    tabMessageClass: "login-error-message",
                    tabMessage: error.getMessage(),
                    timerDuration: typeof error.getErrorData() === "object"
                        ? {
                            minutes: error.getErrorData()
                                .MaxRequestTime,
                            seconds: 0,
                        }
                        : undefined,
                },
            });
        });
    };
    var getMenuList = function (strPartnerCategory) {
        profileDi.profile.getUserMenu({ strPartnerCategory: strPartnerCategory });
    };
    var loginSubmit = function () {
        window.location.href = "https://login.microsoftonline.com/".concat(URLConfig.config.tenantID, "\n    /oauth2/v2.0/authorize?client_id=").concat(URLConfig.config.clientID, "&response_type=code&\n    redirect_uri=").concat(URLConfig.config.applicationRoot, "login&response_mode=query&scope=https%3A%2F%2Fgraph.microsoft.com%2FUser.Read&state=12345");
    };
    var getSSOLoginData = function () {
        props === null || props === void 0 ? void 0 : props.setLoader(true);
        di.login
            .getSSOLoginData({ token: props === null || props === void 0 ? void 0 : props.ssoCode, tokenflag: "sso" })
            .then(function (resp) { })
            .catch(function (error) { })
            .finally(function () {
            props === null || props === void 0 ? void 0 : props.setLoader(false);
        });
    };
    useEffect(function () {
        if (!!(props === null || props === void 0 ? void 0 : props.ssoCode)) {
            getSSOLoginData();
        }
    }, [props === null || props === void 0 ? void 0 : props.ssoCode]);
    useEffect(function () {
        if (loginData === null || loginData === void 0 ? void 0 : loginData.isSaarthi) {
            setIsSaarthi(loginData === null || loginData === void 0 ? void 0 : loginData.isSaarthi);
            setSaarthiMsg(loginData === null || loginData === void 0 ? void 0 : loginData.message);
        }
        if ((loginData === null || loginData === void 0 ? void 0 : loginData.isOtpEnabled) &&
            loginData.screenState === ILoginScreenState.OTP_SCREEN) {
            setShowOtp(loginData === null || loginData === void 0 ? void 0 : loginData.isOtpEnabled);
            setShowOtpLoader(false);
        }
        else if (!!loginData.cipToken &&
            loginData.screenState === ILoginScreenState.SUCCESS) {
            getExpiringLeads();
            navigate(
            // loginDI.login.getIsRMPartnerFRM().isPartner
            //   ? "/dashboard/revenue-dashboard"
            //   :
            "/dashboard");
        }
    }, [loginData]);
    useEffect(function () {
        if (props.userId || password) {
            setServerError({
                isOpen: false,
                errorMessage: "",
            });
        }
        setSaarthiMsg("");
        setIsSaarthi(false);
    }, [props.userId, password, otp]);
    useEffect(function () {
        if (errorState.isOpen) {
            setShowOtpLoader(false);
            setResendOtp(errorState.error.getMessage() ===
                "Reached max attempts, please login again");
            setServerError({
                isOpen: errorState.isOpen,
                errorMessage: errorState.error.getMessage(),
            });
        }
    }, [errorState]);
    useLayoutEffect(function () {
        generateAppId().then(function (appId) {
            // localStorage.setItem("agentId", appId);
            setAppId(appId);
        });
    }, []);
    useEffect(function () {
        if (serverError.isOpen &&
            errorState &&
            errorState.error &&
            errorState.error.getErrorData() &&
            errorState.error.getErrorData().isBlocked) {
            setIsAccountBlocked(true);
            di.login.changeCurrentLoginComponent({
                currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                extraConfig: {
                    tabMessageClass: "login-error-message",
                    messageIcon: React.createElement("i", { className: "edel-icon-forgot-login" }),
                    tabMessage: errorState.error.getMessage(),
                },
            });
        }
    }, [serverError, errorState]);
    useEffect(function () {
        setIsSaarthi(false);
        setSaarthiMsg("");
        setPassword("");
        props.setUserId("");
        setShowOtp(false);
        setServerError({
            isOpen: false,
            errorMessage: "",
        });
    }, [props.loginFor]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (((_b = (_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.forgotLoginIdSuccessDetails) === null || _b === void 0 ? void 0 : _b.userId) &&
            props.loginFor === ERole.Partner) {
            props.setUserId((_d = (_c = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _c === void 0 ? void 0 : _c.forgotLoginIdSuccessDetails) === null || _d === void 0 ? void 0 : _d.userId);
        }
        else {
            props.setUserId("");
        }
    }, [(_b = (_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.forgotLoginIdSuccessDetails) === null || _b === void 0 ? void 0 : _b.userId]);
    return showOtp ? (React.createElement("div", { className: "partner-login" },
        React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey mb-2 lh-140" }, "Enter the OTP sent to registered mobile number and email ID."),
        React.createElement(LoginCommonInputButton, { inputValue: otp, setInputValueCallback: function (value) {
                setOtp(value);
                // setError({
                //   isShowError: false,
                //   errorMessage: "",
                // });
            }, inputPlaceholder: "Enter the OTP", buttonText: "Next", buttonOnClick: validateOTP, buttonDisable: !otp || (otp === null || otp === void 0 ? void 0 : otp.length) < 6, enableClickOnEnter: true, enablePasswordMasking: true, isShowInputLoader: otpLoader, inputType: {
                integer: true,
            }, maxLength: 6, autoFocusOnInput: true }),
        resendOtp && !resendOTPLoader && (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Resend OTP", className: "forgot-login", onClick: resendOTP })),
        resendOtp && resendOTPLoader && (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "sending OTP ...", className: "forgot-login", onClick: resendOTP })),
        serverError && serverError.isOpen && (React.createElement(ErrorExclamation, { errorMessage: serverError.errorMessage })))) : isAccountBlocked && props.loginFor === ERole.Partner ? (React.createElement("div", { className: "d-flex flex-column unblock-account-container gap-1 w-100" },
        React.createElement(LoginCommonInputButton, { buttonOnClick: userUnblockCheck, inputValue: props.userId, setInputValueCallback: function (e) {
                var text = e;
                setEmailError("");
                props.setUserId(e.toUpperCase());
            }, inputPlaceholder: "Enter your partner code", buttonText: "Unblock Account", buttonDisable: !props.userId || isShowLoader, isShowInputLoader: isShowLoader, 
            // errorConfig={{
            //   isShowError: serverError.isOpen,
            //   errorMessage: serverError.errorMessage,
            // }}
            enableClickOnEnter: true, emailError: emailError, onBlurCallbackFunction: function (event) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) &&
                    ((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value) !== "" &&
                    ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.value) !== undefined &&
                    ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.value) !== null &&
                    ((_f = (_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.length) > 0 &&
                    ((_h = (_g = event === null || event === void 0 ? void 0 : event.target) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.includes("@"))) {
                    setEmailError("entered userid is not valid.");
                }
            } }),
        React.createElement(ForgotIDPasswordButton, { showLoginIdBtn: true, tabType: props.loginFor === ERole.Partner ? ERole.Partner : ERole.RM, showForgotPasswordBtn: props.loginFor === ERole.Partner }),
        React.createElement("div", { className: "login-with-another-acc-wrapper" },
            React.createElement(EdButton, { value: "Login with another account", btnTyp: "midnight-blue-underline", className: "back-to-login-btn", onClick: function () {
                    setIsAccountBlocked(false);
                    props.setUserId("");
                    setPassword("");
                    di.login.changeCurrentLoginComponent({
                        currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                        extraConfig: {
                            currentActiveTab: ERole.Partner,
                            messageIcon: React.createElement(React.Fragment, null),
                            tabMessage: "",
                        },
                    });
                } })))) : (React.createElement("div", { className: "partner-login" },
        isSaarthi && props.loginFor === ERole.Partner && (React.createElement(VerificationMsg, { parentClassName: "p-2 rounded-1 bg_pastel-cream mb-2 d-flex  gap-2", message: React.createElement("p", { className: "DMSansNormal_12_400   txt-faded-orange lh-120" },
                "Your mobile number and/or email id needs to be verified in order to proceed.",
                " ",
                React.createElement("a", { className: "cursor-pointer text-nowrap  txt-faded-orange ", href: loginData === null || loginData === void 0 ? void 0 : loginData.message },
                    React.createElement("u", null, "Please click here to verify now."))), icon: "edel-icon-warning-excla txt-faded-orange mt-1" })),
        props.loginFor === ERole.RM && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex justify-content-center align-items-center bg_fantasy quick-login", onClick: function () {
                    loginSubmit();
                } },
                React.createElement("img", { src: microsoftLogo, alt: "logo", width: 26 }),
                React.createElement("span", { className: "DMSanN_14_400" }, "Login via Windows")),
            React.createElement("div", { className: "d-flex justify-content-between align-items-center gap-2 login-choice" },
                React.createElement("span", { className: "border w-100 out-border" }),
                React.createElement("span", { className: "txt_secondary-gray text-nowrap DMSansNormal_12_400" }, "Or login with"),
                React.createElement("span", { className: "border w-100 out-border" })))),
        React.createElement(InputField, { placeholder: "User ID", id: "name", name: "name", autoComplete: "off", defaultValue: (_c = props.userId) !== null && _c !== void 0 ? _c : "", onBlur: function (e, event) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) &&
                    ((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value) !== "" &&
                    ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.value) !== undefined &&
                    ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.value) !== null &&
                    ((_f = (_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.length) > 0 &&
                    ((_h = (_g = event === null || event === void 0 ? void 0 : event.target) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.includes("@"))) {
                    setEmailError("entered userid is not valid.");
                }
            }, onKeyDown: function () { }, maxLength: 50, onChange: function (value) {
                var text = value.toUpperCase();
                setEmailError("");
                props.setUserId(value.toUpperCase());
            }, placeholderClassName: "DMSanN_14_400 txt_secondary-gray", className: " DMSanN_14_400 txt_secondary-gray", errorText: emailError && emailError !== "" ? emailError : "" }),
        React.createElement(InputField, { type: passwordMask ? "password" : "", placeholder: "Password", id: "password", name: "password", autoComplete: "off", defaultValue: password, onChange: setPassword, onBlur: function () { }, onKeyDown: function (e) {
                if (e.key === "Enter" && !!props.userId && !!password) {
                    userLogin();
                }
            }, placeholderClassName: "DMSanN_14_400 txt_secondary-gray", className: "password DMSanN_14_400 txt_secondary-gray p-l", suffix: React.createElement("div", { className: "loader-password-toggle-container d-flex align-items-center" },
                React.createElement(InputPasswordToggle, { isShowPassword: passwordMask, setIsShowPassword: function (value) {
                        setPasswordMask(value);
                    }, inputRef: passwordInputRef }),
                isShowLoader && (React.createElement("div", { className: "input-loader-container" },
                    React.createElement(Loader, null)))), inputRef: passwordInputRef }),
        serverError && serverError.isOpen && !(loginData === null || loginData === void 0 ? void 0 : loginData.isSaarthi) && (React.createElement(Col, { className: "pt-0 error-msg p-0 mgt-10 w-100" },
            React.createElement(ErrorExclamation, { errorMessage: serverError.errorMessage, parentClass: "w-100" }))),
        React.createElement(EdButton, { onClick: function () { return userLogin(); }, btnTyp: "midnight-blue", value: "Proceed", disabled: emailError && emailError != ""
                ? true
                : !serverError.isOpen && props.userId && password
                    ? isSaarthi
                    : true, className: "partner-proceed mgt-10" }),
        React.createElement(ForgotIDPasswordButton, { showLoginIdBtn: props.loginFor === ERole.Partner, tabType: props.loginFor === ERole.Partner ? ERole.Partner : ERole.RM, showForgotPasswordBtn: props.loginFor === ERole.Partner })));
};
export default LoginMain;
